import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isFocused, setIsFocused] = useState(false);

  const handleLanguageChange = (e) => {
    i18n.changeLanguage(e.target.value);
    e.target.blur(); // remove focus after selection
  };

  const currentLang = i18n.language || 'en';

  return (
    <>
      {/* Blur Overlay */}
      <AnimatePresence>
        {isFocused && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backdropFilter: 'blur(8px)',
              backgroundColor: 'rgba(0,0,0,0.2)',
              zIndex: 900,
              pointerEvents: 'none' // allow clicks to pass through to close the select
            }}
          />
        )}
      </AnimatePresence>

      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#f3f4f6', padding: '4px 8px', borderRadius: '20px', position: 'relative', zIndex: 901 }}>
      <Globe size={16} color="#4b5563" />
      <select 
        value={currentLang} 
        onChange={handleLanguageChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        style={{
          background: 'transparent',
          border: 'none',
          outline: 'none',
          fontSize: '0.9rem',
          fontWeight: 600,
          color: '#374151',
          cursor: 'pointer'
        }}
      >
        <option value="en">English</option>
        <option value="fr">Français</option>
        <option value="de">Deutsch</option>
        <option value="ja">日本語</option>
        <option value="es">Español</option>
        <option value="it">Italiano</option>
        <option value="hi">हिन्दी</option>
      </select>
    </div>
    </>
  );
};

export default LanguageSwitcher;
